import styled from 'styled-components';

export default styled.span`
  word-break: keep-all;
  white-space: nowrap;
`;
